import { PropTypes } from 'prop-types';
import styles from './style.m.less';

LoadingIndicator.propTypes = {
    small: PropTypes.bool,
};

const BIG_SIZE = '40px';

export default function LoadingIndicator({ small = true }) {
    const sizeStyle = small ? {} : { height: BIG_SIZE, width: BIG_SIZE };
    return (
        <div className={styles.loading_indicator}>
            <div className={styles.inner}>
                <div className={styles.ball_1} style={sizeStyle} />
                <div className={styles.ball_2} style={sizeStyle} />
            </div>
        </div>
    );
}
